<template>
  <q-layout view="lhh Lpr lff"  >
   
    

      <router-view />

 
  </q-layout>
</template>
<script>

import { mapActions } from 'vuex';
import timer from '@/components/timer'
import store from '../store';
import FooterComponent from '@/components/FooterComponent.vue'
export default {
  name: 'LayoutDefault',
components : {
        timer,
        FooterComponent
    },
     data() {
        return {
      leftDrawerOpen: false,
        userName: '',
        
            StoreStateLogin: store.state.Login,
      }

  },  methods:{
         ...mapActions([
            "triggerLogout",
        ]),
      logout:function(){
         this.triggerLogout();
      }

  }
 ,
  mounted(){
   // alert('non-default')
  
  } 
}
</script>